module.exports = __webpack_public_path__ + "img/desktop.23628016.svg";